<template>
  <div>
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">HOME | MIDONKEY EBIKE</h1>
    <header class="site_header">
      <div class="site_header_top">
        <div class="container clearfix">
          <div class="top-right fontSize d-flex pull-left hidden-xs">
            <div class="contact-item gtag_report_btn">
              {{ $t("common.tel") }}:
              <a href="tel:008676982827404">0086-769-82827404</a>
            </div>
            <div class="contact-item contact-item1 gtag_report_btn">
              {{ $t("common.email") }}:
              <a href="mailto:info@midonkey.com">info@midonkey.com</a>
            </div>
          </div>
          <div class="dropdown lang_dropdown trans-dot5s">
            <div class="btn btn-secondary dropdown-toggle" tabindex="0">
              <i class="fa fa-globe"></i>
              <span id="lang_text">{{ $t("common.language") }}</span>
              <i class="fa fa-angle-down"></i>
            </div>
            <div class="dropdown-menu" aria-labelledby="dropdownLangButton" style="border-radius: 0; padding: 10px; height: 400px; overflow: auto">
              <a class="dropdown-item notranslate noproxy" @click="changeLang('en')" style="font-size: 16px; display: block; margin-bottom: 10px"> English </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('zh')" style="font-size: 16px; display: block; margin-bottom: 10px"> 简体中文 </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('spa')" style="font-size: 16px; display: block; margin-bottom: 10px"> Español </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('fra')" style="font-size: 16px; display: block; margin-bottom: 10px"> Français </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('de')" style="font-size: 16px; display: block; margin-bottom: 10px"> Deutsch </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('it')" style="font-size: 16px; display: block; margin-bottom: 10px"> Italiano </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('ru')" style="font-size: 16px; display: block; margin-bottom: 10px"> Pусский </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('pl')" style="font-size: 16px; display: block; margin-bottom: 10px"> Polskie </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('nl')" style="font-size: 16px; display: block; margin-bottom: 10px"> Nederlands </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('fin')" style="font-size: 16px; display: block; margin-bottom: 10px"> Suomi </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('swe')" style="font-size: 16px; display: block; margin-bottom: 10px"> Svenska </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('pt')" style="font-size: 16px; display: block; margin-bottom: 10px"> Português </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('tr')" style="font-size: 16px; display: block; margin-bottom: 10px"> Türk </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('ara')" style="font-size: 16px; display: block; margin-bottom: 10px"> اللغة العربية </a>
              <!-- <a
                class="dropdown-item notranslate noproxy"
                @click="changeLang('jp')"
                style="font-size: 16px; display: block; margin-bottom: 10px"
              >
                日本語
              </a> -->
              <a class="dropdown-item notranslate noproxy" @click="changeLang('kor')" style="font-size: 16px; display: block; margin-bottom: 10px"> 한국어 </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('th')" style="font-size: 16px; display: block; margin-bottom: 10px"> ภาษาไทย </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('ms')" style="font-size: 16px; display: block; margin-bottom: 10px"> Melayu </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('id')" style="font-size: 16px; display: block; margin-bottom: 10px"> bahasa Indonesia </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('hi')" style="font-size: 16px; display: block; margin-bottom: 10px"> हिंदी </a>
              <a class="dropdown-item notranslate noproxy" @click="changeLang('fa')" style="font-size: 16px; display: block; margin-bottom: 10px"> اردو </a>
            </div>

            <div class="btn btn-secondary dropdown-toggle pull-right visible-xs" tabindex="0">
              <template v-if="token">
                <a href="/OrderList" class="white" style="margin-right: 10px;">{{$t("account.myOrders")}}</a>
                <a href="javascript:;" @click="logout" class="white">{{$t("account.logout")}}</a>
              </template>
              <template v-else>
                <a href="/login?action=signIn" class="white">{{$t("account.signIn")}}</a> / <a href="/login?action=signUp" class="white">{{$t("account.signUp")}}</a>
              </template>
            </div>
          </div>
          <div class="social_list fontSize hidden-sm hidden-xs pull-right">
            <a href="https://www.facebook.com/groups/midonkey" target="_blank">
              <i class="fa fa-facebook-f"></i>
            </a>

            <a href="https://www.linkedin.com/company/midonkey-ebike" target="_blank">
              <i class="fa fa-linkedin" aria-hidden="true"></i>
            </a>

            <a href=" https://www.youtube.com/channel/UCKcW_IcDOyVW_yXxZG2XQEQ" target="_blank">
              <i class="fa fa-youtube" aria-hidden="true"></i>
            </a>

            <a href="https://www.instagram.com/midonkey.ebike/" target="_blank">
              <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>

            <a href="https://www.tiktok.com/@midonkey_ebike" target="_blank">
              <img src="/img/tiktok-icon-white.png" alt="img" style="width: 28px" />
            </a>
          </div>
        </div>
      </div>
      <div class="site_header_bottom sticky-enabled">
        <div class="container clearfix" style="position: relative">
          <div class="menu-close">
            <i class="fa fa-times" aria-hidden="true"></i>
          </div>
          <div class="menu-handler pull-right">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="h-logo pull-left">
            <a href="/">
              <img src="/img/logo.png" alt="HOME | MIDONKEY EBIKE" />
            </a>
          </div>
          <div v-if="token" class="site_quick_quote trans-dot5s pull-right text-capitalize hidden-xs" style="margin-left: 10px;">
            <a href="javascript:;" @click="logout" class="white">{{$t("account.logout")}}</a>
          </div>
          <div v-if="token" class="site_quick_quote trans-dot5s pull-right text-capitalize hidden-xs">
            <a href="/OrderList" class="white">{{$t("account.myOrders")}}</a>
          </div>
          <div v-if="!token" class="site_quick_quote trans-dot5s pull-right text-capitalize hidden-xs">
            <a href="/login?action=signIn" class="white">{{$t("account.signIn")}}</a> / <a href="/login?action=signUp" class="white">{{$t("account.signUp")}}</a>
          </div>
          <div class="searchbox pull-right hidden-xs">
            <i class="fa fa-search" data-flag="false"></i>
            <div class="search_g_box">
              <div class="d-flex" action="/search/products" method="GET" siq_id="autopick_9328">
                <input type="text" name="keyword" :placeholder="$t('common.searchProductOnly')" />
                <button type="submit"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </div>
          <ul class="main-menu hidden-md hidden-sm hidden-xs pull-right">
            <li class="dropdown-menu1" :class="$route.path === '/' ? 'current' : ''">
              <a href="/">{{ $t("common.home") }}</a>
            </li>
            <li class="dropdown-menu1" :class="$route.path === '/About' ? 'current' : ''">
              <router-link to="/About">{{ $t("common.about") }}</router-link>
            </li>
            <li class="dropdown-menu1" :class="$route.path === '/Products' ? 'current' : ''">
              <router-link to="/Products">{{ $t("common.products") }}</router-link>
            </li>
            <li class="dropdown-menu1" :class="$route.path === '/Services' ? 'current' : ''">
              <router-link to="/Services">{{ $t("common.oemAndodm") }}</router-link>
            </li>
            <li class="dropdown-menu1" :class="$route.path === '/Support' ? 'current' : ''">
              <router-link to="/Support">{{ $t("common.support") }}</router-link>
            </li>
            <li class="dropdown-menu1" :class="$route.path === '/Contact' ? 'current' : ''">
              <router-link to="/Contact">{{ $t("common.contact") }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <div class="mobile-menu" style="padding-bottom: 90px">
      <div class="menu-close">
        <span></span>
        <span></span>
      </div>
      <div class="site-logo">
        <a href="/"><img src="/img/logo.png" alt="HOME | MIDONKEY EBIKE" width="239" height="60" style="max-width: 230px" /></a>
      </div>
      <div class="mobile-menu-items">
        <ul class="primary-menu">
          <li class="menu-list current">
            <a href="/">{{ $t("common.home") }}</a>
          </li>
          <li class="menu-list">
            <a href="/About">{{ $t("common.about") }}</a>
          </li>
          <li class="menu-list">
            <a href="/Products">{{ $t("common.products") }}</a>
          </li>
          <li class="menu-list">
            <a href="/Services">{{ $t("common.oemAndodm") }}</a>
          </li>
          <li class="menu-list">
            <a href="/Support">{{ $t("common.support") }}</a>
          </li>
          <li class="menu-list">
            <a href="/Contact">{{ $t("common.contact") }}</a>
          </li>
        </ul>
      </div>
    </div>

    <router-view />

    <footer class="footer-section overflow">
      <div class="container">
        <div class="row overflow">
          <div class="col-md-4 col-sm-12 col-xs-12 ft-column ft-column1 wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
            <div class="ft_logo">
              <a href="/"><img src="/img/logo-white.png" alt="HOME | MIDONKEY EBIKE" style="max-width: 228px" /></a>
            </div>
            <div class="footer_slogan">
              {{ $t("footer.fot1") }}
            </div>
            <div class="social_list fontSize">
              <a href="https://www.facebook.com/groups/midonkey" target="_blank">
                <i class="fa fa-facebook-f"></i>
              </a>

              <a href="https://www.linkedin.com/company/midonkey-ebike" target="_blank">
                <i class="fa fa-linkedin" aria-hidden="true"></i>
              </a>

              <a href=" https://www.youtube.com/channel/UCKcW_IcDOyVW_yXxZG2XQEQ" target="_blank">
                <i class="fa fa-youtube" aria-hidden="true"></i>
              </a>

              <a href="https://www.instagram.com/midonkey.ebike/" target="_blank">
                <i class="fa fa-instagram" aria-hidden="true"></i>
              </a>

              <a href="https://www.tiktok.com/@midonkey_ebike" target="_blank">
                <img src="/img/tiktok-icon.png" alt="img" style="width: 28px" />
              </a>
            </div>
          </div>
          <div class="col-md-8 col-sm-12 col-xs-12 footer-nav-wrap">
            <div class="col-md-4 col-sm-6 col-xs-12 ft-column ft-column1 wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <h6 class="ft-title text-uppercase">{{ $t("footer.fot2") }}</h6>

              <div class="ft-nav">
                <router-link to="/About"> {{ $t("footer.fot3") }}</router-link>

                <router-link to="/Subsidiaries"> {{ $t("footer.fot4") }}</router-link>

                <router-link to="/Factory"> {{ $t("footer.fot5") }}</router-link>

                <router-link to="/Certificates"> {{ $t("footer.fot6") }}</router-link>

                <router-link to="/Articles"> {{ $t("footer.fot7") }}</router-link>

                <router-link to="/Careers">{{ $t("footer.fot8") }}</router-link>

                <router-link to="/Feedback">{{ $t("footer.fot9") }}</router-link>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12 ft-column ft-column2 wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <h6 class="ft-title text-uppercase">{{ $t("footer.fot10") }}</h6>
              <div class="ft-nav">
                <router-link to="/Contact">{{ $t("footer.fot11") }}</router-link>

                <router-link to="/Services">{{ $t("footer.fot12") }}</router-link>

                <router-link to="/FAQ">{{ $t("footer.fot13") }}</router-link>

                <router-link to="/Returns">{{ $t("footer.fot14") }}</router-link>

                <router-link to="/Delivery">{{ $t("footer.fot15") }}</router-link>

                <a href="https://forms.zohopublic.com/midonkey/form/RegisterYourEbike/formperma/T6dLCCvn14DX1ahGeBmI4Ml7blRhPEGzSkHqb7xX9Y0">{{ $t("footer.fot16") }}</a>

                <router-link to="/Warranty">{{ $t("footer.fot17") }}</router-link>

                <router-link to="/Catalogues">{{ $t("footer.fot18") }}</router-link>

                <router-link to="/Guides">{{ $t("footer.fot19") }}</router-link>

                <a href="https://zcmpsub.maillist-manage.com/ua/Optin?od=11287ecbcf7dfb&amp;zx=12dbb92e1&amp;sD=1c6b0bde3735056d">{{ $t("footer.fot20") }}</a>

                <router-link to="/Recycling">{{ $t("footer.fot21") }}</router-link>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xs-12 ft-column ft-column3 wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
              <h6 class="ft-title text-uppercase">{{ $t("footer.fot22") }}</h6>
              <div class="footer-form-validate footer-message-form form-ade37d4caec88ab9644f918506e4d237" action="https://inquiry.digoodcms.com/api/administrator" method="POST" novalidate siq_id="autopick_9652">
                <input name="page" type="hidden" value="https://www.midonkey.com/" />
                <input id="backpage2" name="backpage" type="hidden" value="https://www.midonkey.com/inquiryok?back=/" />

                <div class="form-group">
                  <input v-model="modalParameter.userName" type="text" id="name" name="contact[fullname]" class="form-control1" :placeholder="$t('footer.fot23')" required />
                </div>
                <div class="form-group">
                  <input v-model="modalParameter.userEmail" type="email" id="email" name="email" class="form-control1" :placeholder="$t('footer.fot24')" required pattern="[\w!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[\w!#$%&amp;'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?" />
                </div>
                <div class="form-group message-group">
                  <textarea v-model="modalParameter.context" id="message" name="message" class="form-control1" :placeholder="$t('footer.fot25')"></textarea>
                </div>
                <div class="form-group1">
                  <button class="submit-btn trans-dot5s" @click="submit()" type="submit">
                    {{ $t("footer.fot26") }}
                  </button>
                </div>
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_ipAddress" name="custom[ipAddress]" type="hidden" value="113.91.52.137" />
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_countryName" name="custom[countryName]" type="hidden" value="China" />
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_regionName" name="custom[regionName]" type="hidden" value="Guangdong" />
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_cityName" name="custom[cityName]" type="hidden" value="Shenzhen" />
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_countryCode" name="custom[countryCode]" type="hidden" value="CN" />
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_zipCode" name="custom[zipCode]" type="hidden" value="" />
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_latitude" name="custom[latitude]" type="hidden" value="22.5318" />
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_longitude" name="custom[longitude]" type="hidden" value="114.1374" />
                <input class="custom-af1d1f4ff867a1499bd772c371f6936a_timeZone" name="custom[timeZone]" type="hidden" value="Asia/Shanghai" />

                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_ipAddress" name="geoip[ipAddress]" type="hidden" value="113.91.52.137" />
                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_countryName" name="geoip[countryName]" type="hidden" value="China" />
                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_countryCode" name="geoip[countryCode]" type="hidden" value="CN" />
                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_regionName" name="geoip[regionName]" type="hidden" value="Guangdong" />
                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_cityName" name="geoip[cityName]" type="hidden" value="Shenzhen" />
                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_zipCode" name="geoip[zipCode]" type="hidden" value="" />
                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_latitude" name="geoip[latitude]" type="hidden" value="22.5318" />
                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_longitude" name="geoip[longitude]" type="hidden" value="114.1374" />
                <input class="geo-1ca1801a4d9e1eb4abb821270c91d62e_timeZone" name="geoip[timeZone]" type="hidden" value="Asia/Shanghai" />
                <input name="useragent[browser]" type="hidden" value="Chrome[86.0.4240.75]" />
                <input name="useragent[platform]" type="hidden" value="Windows 10" />
                <input name="useragent[lang]" type="hidden" value="zh-CN,zh;q=0.9,ja;q=0.8,en-US;q=0.7,en;q=0.6,zh-TW;q=0.5" />
                <input name="useragent[mobile]" type="hidden" value="No" />
                <input name="useragent[agent_string]" type="hidden" value="Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.75 Safari/537.36" />

                <input name="country" type="hidden" value="CN" />
              </div>
            </div>
          </div>
        </div>
        <div class="ft_info_box">
          <div class="row">
            <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12 info-left">
              <div class="ft_copyright wow fadeInUp" style="font-size: 15px; visibility: visible; animation-name: fadeInUp">
                {{ $t("footer.fot27") }}
              </div>
              <div class="ft_info_right wow fadeInUp hidden-xs" style="font-size: 15px; visibility: visible; animation-name: fadeInUp">
                <router-link to="/PrivacyPolicy" class="wow fadeInUp policy" style="visibility: visible; animation-name: fadeInUp">{{ $t("footer.fot28") }}</router-link>
                <router-link to="/CookiePolicy" class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">{{ $t("footer.fot29") }}</router-link>
                <router-link to="/Terms" class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">{{ $t("footer.fot30") }}</router-link>
                <!-- <a
                  hrefs="https://www.midonkey.com/sitemap.html"
                  class="wow fadeInUp"
                  style="visibility: visible; animation-name: fadeInUp"
                  >{{ $t("footer.fot31") }}</a
                > -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- <section id="_section-links_1k55i_757">
      <div class="_container_1k55i_128">
        <div class="_tags-box_13kno_350 _center_1k55i_505">
          <h4 class="_section-title_1k55i_500">{{ $t("footer.fot32") }}</h4>
          <a hrefs="https://www.midonkey.com/dlp/electric-bike.html">{{
            $t("footer.fot33")
          }}</a>
          <a hrefs="https://www.midonkey.com/dlp/e-bike.html">{{
            $t("footer.fot34")
          }}</a>
          <a hrefs="https://www.midonkey.com/dlp/electric-bicycle.html">{{
            $t("footer.fot35")
          }}</a>
          <a hrefs="https://www.midonkey.com/dlp/electric-mountain-bike.html">{{
            $t("footer.fot36")
          }}</a>
          <a
            hrefs="https://www.midonkey.com/dlp/electric-bicycle-battery.html"
            >{{ $t("footer.fot37") }}</a
          >
        </div>
      </div>
    </section> -->
    <div class="scroll_to_top">
      <i class="fa fa-angle-double-up" aria-hidden="true"></i>
    </div>

    <svg style="display: none">
      <symbol id="arrow-right" viewBox="0 0 24 24" preserveAspectRatio="xMinYMin meet">
        <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
      </symbol>
    </svg>

    <div style="position: fixed; top: 30%; left: 30%; right: 30%; z-index:1 ; text-align: center;" class="alert alert-danger" v-if="show" role="alert">{{ show }}</div>
<div style="position: fixed; top: 30%; left: 40%; right: 40%; padding: 20px 0; z-index: 1; text-align: center;" class="alert-success" v-if="successShow" role="alert">
<span class="glyphicon glyphicon-ok"></span>
</div>

  </div>
</template>
<script setup>
import { onMounted } from "vue"
import { loadLanguageAsync } from "@/i18n"


import { reactive,getCurrentInstance ,ref} from 'vue';
import {saveConcat} from '@/utils/api.js'
const { proxy } = getCurrentInstance()
let modalParameter = reactive({
  userName:'',
  userEmail:'',
  context:'',
  userPhone:''
})

let show = ref(false);
let token = ref(localStorage.getItem("token"));
let  successShow = ref(false);

const logout = () => {
  localStorage.removeItem("token")
  window.location.href = "/"
}

let submit = ()=>{
  if(  successShow.value){
    return
  }
  show.value = false;
  for(let i in modalParameter){
    if(i!='userPhone' && !modalParameter[i]){
     show.value = i == 'userName'?'fullName':i=='userEmail'?'usEmail':i=='context'?'message':'';
    }
  }
  if(show.value){
    // alert(proxy.$t('contact.'+show))
   show.value = proxy.$t('contact.'+show.value);

   setTimeout(() => {
    show.value = false;
   }, 3000);
    return
  }

  saveConcat(modalParameter).then(res=>{
    if(res.code =='000000'){
      for(let i in modalParameter){
       modalParameter[i] = '';
  }
 successShow.value = true;
  setTimeout(() => {
    successShow.value = false;
  }, 3000);
    }
  })
}



const changeLang = (lang) => {
  loadLanguageAsync(lang)
}
onMounted(() => {
  if (/msie|trident/i.test(navigator.userAgent)) {
    $("img").each(function (index, item) {
      var src = $(this).attr("src")
      if (/\/format\/webp/i.test(src)) {
        $(this).attr("src", src.replace(/\/format\/webp/g, ""))
      }
    })
  }
  if (!/msie [6|7|8|9]/i.test(navigator.userAgent) && WOW) {
    new WOW().init()
  }
  // lazyload
  $("div.lazy, section.lazy, img.lazy").lazyload({
    threshold: 20
  })
  // back to top
  function el(el) {
    return document.querySelector(el)
  }
  if (el(".scroll_to_top")) {
    el(".scroll_to_top").onclick = function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  }
  $(".dropdown-toggle").click(function () {
    $(".dropdown-menu").toggle()
  })
  $(".dropdown-toggle").blur(function () {
    setTimeout(() => {
      $(".dropdown-menu").toggle()
    }, 300)
  })

  // mobile-nav Start
  $(".menu-handler").on("click", function () {
    $(".block-bg,.mobile-menu").addClass("menu-on")
  })
  $(".menu-close, .block-bg").click(function () {
    $(".block-bg,.mobile-menu").removeClass("menu-on")
  })
  $(".mobile-menu .primary-menu > .menu-list > .dd-trigger").click(function () {
    if (!$(".sub-menu").is(":animated")) {
      $(this).parent("li").toggleClass("on").siblings().removeClass("on")
      $(this).parent("li").siblings().children(".sub-menu").slideUp()
      $(this).parent("li").children(".sub-menu").slideToggle()
    }
    return false
  })
  $(".mobile-menu .primary-menu > .menu-list > .sub-menu > .menu-list > .dd-trigger").click(function () {
    if (!$(".sub-menu").is(":animated")) {
      $(this).parent("li").toggleClass("on").siblings().removeClass("on")
      $(this).parent("li").siblings().children(".sub-menu").slideUp()
      $(this).parent("li").children(".sub-menu").slideToggle()
    }
    return false
  })
  // mobile-nav End
  window.onscroll = function (e) {
    let topdistance = document.documentElement.scrollTop || document.body.scrollTop
    if (el(".scroll_to_top")) {
      if (topdistance > 800) {
        $(".scroll_to_top").addClass("active")
      } else {
        $(".scroll_to_top").removeClass("active")
      }
    }
  }
  // back to top

  // Fixed header.
  $(window).on("resize", function () {
    fixedHeader()
  })
  function fixedHeader() {
    var stickyOffsetTop = $(".sticky-enabled")[0].offsetTop
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > stickyOffsetTop && !$(".sticky-enabled").hasClass("sticky-header")) {
        $(".sticky-enabled").addClass("sticky-header")
      } else if ($(window).scrollTop() <= stickyOffsetTop) {
        $(".sticky-enabled").removeClass("sticky-header")
      }
    })
  }
  fixedHeader()

  // img
  $("img").each(function (item, index) {
    var alt = $(this).attr("alt")
    if (!alt) {
      $(this).attr("alt", "HOME | MIDONKEY EBIKE") // 随机取一个前缀词、后缀词+index
    }
  })

  // searchbox
  $(".searchbox>.fa-search").click(function (e) {
    var f = $(this).data("flag")
    if (f == false) {
      $(this).data("flag", true)
      $(".search_g_box").fadeIn(100)
    } else {
      $(this).data("flag", false)
      $(".search_g_box").fadeOut(100)
    }
  })

  $(document).click(function (e) {
    $(".search_g_box").fadeOut(100)
    $(".searchbox>.fa-search").data("flag", false)
  })

  $(".search_g_box, .searchbox>.fa-search").click(function (e) {
    e = e || window.event
    if (e.stopPropagation) {
      e.stopPropagation()
    } else {
      e.cancelBubble = true
    }
  })
})
</script>
<style>
.custom_page_content {
  padding: 60px 0;
}

.custom_page_content ol,
.custom_page_content ul {
  padding-left: 20px;
}

.custom_page_content ul li {
  list-style: initial;
}

.custom_page_content ol li {
  list-style: inherit;
}

.custom_page_content em,
.custom_page_content i {
  font-style: italic;
}

@media (max-width: 991px) {
  .custom_page_content {
    padding: 52px 0;
  }
}

@media (max-width: 767px) {
  .custom_page_content {
    padding: 45px 0;
  }
}

.margint20 {
  margin-top: 20px;
}

.categories-widget .sidebar-title {
  font-weight: 700;
  font-size: 18px;
  margin: 0;
}

.categories-widget.card {
  position: relative;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  border-top: solid 1px #f5f5f5;
  bottom: 0;
}

.categories-widget.card-padding {
  padding: 20px;
}

.categories-widget .list-style {
  padding-left: 0 !important;
}

.categories-widget .list-style li {
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  box-shadow: 0 0 1px transparent;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
  list-style: none !important;
}

.categories-widget .list-style li:active,
.categories-widget .list-style li:focus,
.categories-widget .list-style li:hover {
  -webkit-transform: translateX(8px);
  transform: translateX(8px);
}

.categories-widget .list-style i {
  margin-left: 0;
  margin-right: 7px;
  color: #666;
  line-height: 30px;
  font-style: normal;
}

.support-thumbnail {
  padding: 25px;
}
#_section-links_1k55i_757 {
  padding: 60px 0 30px;
  background-color: #f8f9fa;
}
#_section-links_1k55i_757 ._container_1k55i_128,
#_section-links_1k55i_757 ._container-fluid_1k55i_128 {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
._section-title_1k55i_500 {
  font-size: 24px;
  margin-bottom: 15px;
  font-weight: 500;
  color: #333;
}
._center_1k55i_505._tags-box_13kno_350 {
  text-align: center;
}
@media (min-width: 576px) {
  #_section-links_1k55i_757 ._container_1k55i_128 {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  #_section-links_1k55i_757 ._container_1k55i_128 {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  #_section-links_1k55i_757 ._container_1k55i_128 {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  #_section-links_1k55i_757 ._container_1k55i_128 {
    max-width: 1140px;
  }
}
#_section-links_1k55i_757._section-padding_1k55i_514 {
  padding: 60px 0;
}
#_section-links_1k55i_757 ._section-header_1k55i_505 {
  margin-bottom: 30px;
}
#_section-links_1k55i_757 ._tags-box_13kno_350 span {
  color: #343434;
  font-weight: 600;
}

#_section-links_1k55i_757 ._tags-box_13kno_350 a {
  font-size: 12px;
  padding: 5px 10px;
  border: 1px dashed transparent;
  display: inline-block;
  color: #666666;
  text-transform: capitalize;
}

#_section-links_1k55i_757 ._icon_13kno_264 {
  color: inherit;
  fill: currentColor;
  height: 1em;
  width: 1em;
  vertical-align: middle;
}

#_section-links_1k55i_757 ._tags-box_13kno_350 a:hover {
  border-color: #666;
}
#_section-links_1k55i_757._dark_13kno_387 {
  background: #1c2135;
}
#_section-links_1k55i_757._dark_13kno_387 ._section-header_1k55i_505 ._section-title_1k55i_505 {
  color: #fff;
}
#_section-links_1k55i_757._dark_13kno_387 ._tags-box_13kno_350 span {
  color: #eee;
}
#_section-links_1k55i_757._dark_13kno_387 ._tags-box_13kno_350 a:hover {
  border-color: #eee;
  color: #666666;
}
[dir="rtl"] #_section-links_1k55i_757 {
  text-align: right;
}

._tags-tab_13kno_350 {
  display: flex;
  flex-direction: column;
}
._tags-tab_13kno_350 .tab-nav {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin-bottom: 15px;
}
._tags-tab_13kno_350.vetical {
  flex-direction: row;
}
._tags-tab_13kno_350.vetical .tab-nav {
  flex-direction: column;
  margin-right: 15px;
  padding-right: 15px;
  border-right: 1px solid #ddd;
}
._tags-tab_13kno_350.vetical .tab-nav .tab-item {
  width: 150px;
  padding: 5px 10px;
  margin-right: 0.5rem;
  border-bottom: 1px solid transparent;
}
@media (min-width: 768px) {
  ._tags-tab_13kno_350.vetical .tab-nav .tab-item {
    width: 220px;
  }
}
._tags-tab_13kno_350 .tab-nav .tab-link {
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
  color: #666666;
}
._tags-tab_13kno_350.vetical .tab-nav .tab-item {
  padding: 5px 0;
  margin-bottom: 5px;
}
._tags-tab_13kno_350 .tab-nav .tab-link ._icon_13kno_264 {
  margin-right: 0.5rem;
}
._tags-tab_13kno_350 .tab-nav .tab-item {
  margin-right: 1.5rem;
  margin-bottom: 0.5rem;
}
._tags-tab_13kno_350 .tab-nav .tab-item.active {
  border-color: #666666;
}
._tags-tab_13kno_350 .tab-nav .tab-item.active .tab-link {
  color: #666666;
}
._tags-tab_13kno_350.vetical .tab-content {
  min-height: 200px;
}
._tags-tab_13kno_350 .tab-content .tab-pane {
  display: none;
  height: 150px;
}
._tags-tab_13kno_350 .tab-content .tab-pane.show {
  display: block;
}
[dir="rtl"] ._tags-tab_13kno_350 .tab-nav .tab-link ._icon_13kno_264 {
  margin-right: 0;
  margin-left: 0.5rem;
}
[dir="rtl"] ._tags-tab_13kno_350 .tab-nav .tab-link {
  margin-right: 0;
  margin-left: 0.5rem;
}
</style>
